import React, { useEffect, useMemo, useState } from "react";
import { LivechatSubjectType } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/webvideo/UserPublicDataProvider";
import { parseISO } from "@scrile/tools/dist/lib/TimeHelpers";
import useConsumeController from "hooks/useConsumeController";
import useLiveChat from "hooks/useLiveChat";
import { ProduceUser } from "types";
import PublicStreamView from "../PublicStreamView";

interface Props {
  produceUser: UserPublicData;
  onClose: () => void;
  livechatSubject: Subject<LivechatSubjectType>;
  disableAttachments?: boolean;
}

function ConsumeController({ produceUser, livechatSubject, onClose, disableAttachments }: Props) {
  const { loading, token, userList, joinData, clientServerTimeDiff, endChat } = useLiveChat({
    livechatSubject,
  });

  const { users } = useConsumeController({
    joinData,
    token,
  });

  const [usersToView, setUsersToView] = useState<ProduceUser[]>([]);

  useEffect(() => {
    setUsersToView(Object.values(users));
  }, [users]);

  const onCloseChat = () => {
    endChat().then(() => onClose());
  };

  const streamStartedDate = useMemo(() => {
    const producer = joinData?.users.find((i) => i.userId === produceUser.id);
    if (!producer) {
      return "";
    }
    return new Date(parseISO(producer.joinTime).getTime() + clientServerTimeDiff).toISOString();
  }, [clientServerTimeDiff, joinData, produceUser]);

  return (
    <PublicStreamView
      produceUser={produceUser}
      threadId={joinData?.threadId}
      produce={false}
      loading={loading}
      userList={userList}
      streamStartedDate={streamStartedDate}
      onClose={onCloseChat}
      token={token}
      managedConstraints={null}
      disableAttachments={disableAttachments}
      showConfirmationExit={false}
      users={usersToView}
      me={null}
    />
  );
}
export default ConsumeController;
